
import React, { useState, useEffect,useRef } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import axios from "axios";
import { useYearContext } from "../components/YearContext";
import "../../client/pages/Clientdocuments.css";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {toast} from "react-toastify";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
 
 
function Clientviewdocs() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
 
  const { yearSelected } = useYearContext();
 
  const navigate = useNavigate();
 
  const location = useLocation();
  const fileInputRef = useRef(null);
 
// const[clientMail,setClientMail] = useState("");
//   useEffect(() => {
//     const { clientEmail } = location.state || {};
 
//     if (clientEmail) {
//       fetchClientDocuments(clientEmail);
//       setClientMail(clientEmail);
//     }
//   }, [location]);


const [clientMail, setClientMail] = useState("");

useEffect(() => {
  const { clientEmail } = location.state || {};

  if (clientEmail) {
    // Store in sessionStorage if clientEmail is from location.state
    sessionStorage.setItem('clientEmail', clientEmail);
    fetchClientDocuments(clientEmail);
    setClientMail(clientEmail);
  } else {
    // Retrieve from sessionStorage if no clientEmail from location.state
    const savedClientEmail = sessionStorage.getItem('clientEmail');
    if (savedClientEmail) {
      fetchClientDocuments(savedClientEmail);
      setClientMail(savedClientEmail);
    }
  }
}, [location]);

 
  const [activeTab, setActiveTab] = useState("client");
 
  const [clientDocuments, setClientDocuments] = useState([]);
 
  // Handle switching tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
 
  const fetchClientDocuments = async (username) => {
    await axios
      .get(`https://api.easytaxexperts.com/clientDocuments/${username}`)
 
      .then((response) => {
        if (response.data.success) {
          setClientDocuments(response.data.clientDocuments);
        } else {
          console.error(
            "Error fetching client documents:",
            response.data.message
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching client documents:", error);
      });
  };
 
  const [show, setShow] = useState(false);
 
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
 
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedComment, setSelectedComment] = useState("");
  const [username, setUsername] = useState("");
 
  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.email);
 
        if (decoded.role !== "admin") {
          // navigate("/");
        }
      } catch (error) {
        console.error("Invalid token");
        // navigate("/");
      }
    }
  }, []);
 
 
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };
 
  const handleDocumentTypeChange = (e) => {
    setSelectedDocumentType(e.target.value);
  };
 
  const handleCommentChange = (e) => {
    setSelectedComment(e.target.value);
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (!selectedDocumentType || !selectedFile) {
      toast.warn("Please fill all required fields");
      return;
    }
 
    try {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("document_type", selectedDocumentType);
      formData.append("file", selectedFile);
      formData.append("add_comment", selectedComment);
      formData.append("clientEmail", clientMail);
      formData.append("taxyear", yearSelected);   
 
      const response = await axios.post(
        "https://api.easytaxexperts.com/adminuploadeddocs",
        formData,
       
      );
 
      if (response.data.success) {
        toast.success("Document submitted successfully");
        window.location.reload();
        setSelectedFile(null);
        setSelectedDocumentType("");
        setSelectedComment("");
      } else {
        toast.error("Error submitting document");
      }
    } catch (error) {
      console.error("Error during document submission:", error);
    }
  };
 


  const handleDownloaddoc = (filePath) => {
    // Replace backslashes with forward slashes in the filePath
    const formattedFilePath = filePath.replace(/\\/g, "/");
 
    // Construct the download URL based on the formatted filePath
    const downloadUrl = `https://api.easytaxexperts.com/${formattedFilePath}`;
 
    // Create a temporary link
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
 
    link.download = formattedFilePath.split("/").pop(); // Set the file name
 
    // Append the link to the body
    document.body.appendChild(link);
 
    // Programmatically click on the link to trigger the download
    link.click();
 
    // Remove the link from the body
    document.body.removeChild(link);
  };
 
  // const filterDocuments = clientDocuments.filter((doc) => {
  //   const documentDate = doc.uploaded_on
  //     ? doc.uploaded_on.substring(0, 10)
  //     : "";
  //   const nextYear = (parseInt(yearSelected) + 1).toString();
  //   const startDate = `${parseInt(nextYear) - 1}-09-01`;
  //   const endDate = `${nextYear}-08-31`;
  //   const isYearMatch = documentDate >= startDate && documentDate <= endDate;
  //   return isYearMatch;
  // });
 
 
  const filterDocuments = clientDocuments.filter(
  (doc) => doc.taxyear?.toString() === yearSelected.toString()
);
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = filterDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);
 
  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };
 
  const handleDelete = async(id) => {
    Swal.fire({
      title: "Are you sure?",
      position: "top",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        popup: "swal-custom-height", // Apply custom class here
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
    try{
      const response = await axios.delete(`https://api.easytaxexperts.com/deletedoc/${id}`);
 
      if(response.data.success){
        toast.success("Document deleted succesfully");
        window.location.reload();
 
      }
 
    }catch(error){
      console.log(error);
 
    }
 
  }
});
  }
 
  return (
    <div>
      <Uppercase />
      <div className="client-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div>
              <div className="d-flex justify-content-between">
              <h4>Documents</h4>
              <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleShow}
                >
                  Upload Document
                </button>
                </div>
 
                <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="form-group">
                    <label htmlFor="dropdownInput">Document Type:</label>
                    <select
                      className="form-control"
                      id="dropdownInput"
                      name="dropdownInput"
                      onChange={handleDocumentTypeChange}
                      value={selectedDocumentType}
                    >
                      <option value="" disabled>
                        Select Document Type
                      </option>
                      <optgroup label="Income Forms" className="red-label">
                        <option value="W-2 - Wage and salary income">W-2 - Wage and salary income.</option>
                        <option value="W-2C - Corrected Wage and Tax Statement">W-2C - Corrected Wage and Tax Statement.</option>
                        <option value="W2-G - Certain Gambling Winnings">
                        W2-G - Certain Gambling Winnings.
                        </option>
                        <option value="1042-S - Foreign person's U.S. source income">1042-S - Foreign person's U.S. source income.</option>
                       
                      </optgroup>
                      <optgroup label="Foreign Wage Statement" className="red-label">
                        <option value="K-1  - Income from partnerships, S corporations, estates, or trusts">
                        K-1  - Income from partnerships, S corporations, estates, or trusts.
                        </option>
                        <option value="1099-INT - Interest income">
                        1099-INT - Interest income.
                        </option>
                        <option value="1099-DIV - Dividend income">
                        1099-DIV - Dividend income.
                        </option>
                        <option value="1099-B - Proceeds from Broker and Barter Exchange Transactions">
                        1099-B - Proceeds from Broker and Barter Exchange Transactions.
                        </option>
                        <option value="1099-NEC - Non-employee compensation">
                        1099-NEC - Non-employee compensation.
                        </option>
                        <option value="1099-MISC -Miscellaneous Income">
                        1099-MISC -Miscellaneous Income.
                        </option>
                        <option value="1099-G - Certain Government Payments">
                        1099-G - Certain Government Payments.
                        </option>
                        <option value="1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc">
                        1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc.
                        </option>
                        <option value="1099-K -Payment Card and Third-Party Network Transactions">
                        1099-K -Payment Card and Third-Party Network Transactions.
                        </option>
                        <option value="1095-A - Health Insurance Marketplace Statement">
                        1095-A - Health Insurance Marketplace Statement.
                        </option>
                        <option value="1099-S -Proceeds From Real Estate Transactions">
                        1099-S -Proceeds From Real Estate Transactions.
                        </option>
                        <option value="1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs">
                        1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs.
                        </option>
                        <option value="1099-C -Cancellation of Debt (discharged debt may be considered taxable income)">
                        1099-C -Cancellation of Debt (discharged debt may be considered taxable income).
                        </option>
                        <option value="1099-LTC - Long-Term Care and Accelerated Death Benefits">
                        1099-LTC - Long-Term Care and Accelerated Death Benefits.
                        </option>
                        <option value="1099-RRB - Railroad Retirement Benefits">
                        1099-RRB - Railroad Retirement Benefits.
                        </option>
                        <option value="1099-Q - Payments from Qualified Education Programs">
                        1099-Q - Payments from Qualified Education Programs.
                        </option>
                      </optgroup>
                      <optgroup label="Expense Forms" className="red-label">
                        <option value="1098 - Mortgage interest payments">1098 - Mortgage interest payments.</option>
                        <option value="1098-T -Tuition Statement">1098-T -Tuition Statement</option>
                        <option value="1098-E -Student Loan Interest Statement">1098-E -Student Loan Interest Statement</option>
                        <option value="1098-F -Fines, Penalties, and Other Amounts">1098-F -Fines, Penalties, and Other Amounts</option>
                        <option value="1098-C -Contributions of Motor Vehicles, Boats, and Airplanes">1098-C -Contributions of Motor Vehicles, Boats, and Airplanes</option>
                        <option value="Foreign Home Interest Certificate/Statement From Bank">Foreign Home Interest Certificate/Statement From Bank</option>
                       
                      </optgroup>
                      <optgroup label="Others" className="red-label">
                        <option value="Tax Organizer">Tax Organizer</option>
                        <option value="Prior Year Tax Return Copy">Prior Year Tax Return Copy</option>
                        <option value="Tax Summary">Tax Summary</option>
                        <option value="Client Copy">Client Copy</option>
                        <option value="IDS">IDS</option>
                        <option value="Final Draft">Final Draft</option>
                        <option value="Paper Filing Instructions">Paper Filing Instructions</option>
                        <option value="Other Documents">Other Documents</option>                       
                      </optgroup>
                    </select>
                  </div>
                  <div className="form-group mt-3">
                    <label htmlFor="fileInput">Upload File:</label>
                    <input
                      ref={fileInputRef}
                      type="file"
                      className="form-control-file"
                      id="fileInput"
                      name="fileInput"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label htmlFor="commentInput">Add Comment:</label>
                    <textarea
                      className="form-control"
                      id="commentInput"
                      name="commentInput"
                      rows="3"
                      onChange={handleCommentChange}
                      value={selectedComment}
                    ></textarea>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
 
              <div>
                <ul
                  className="nav nav-tabs mt-3 doctabs"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <a
                      className={`doclinks nav-link ${
                        activeTab === "client" ? "active" : ""
                      }`}
                      id="home-tab"
                      data-toggle="tab"
                      href="#home"
                      role="tab"
                      aria-controls="home"
                      aria-selected={activeTab === "client"}
                      onClick={() => handleTabChange("client")}
                    >
                      Client Uploaded Documents
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className={`doclinks nav-link ${
                        activeTab === "taxExpert" ? "active" : ""
                      }`}
                      id="profile-tab"
                      data-toggle="tab"
                      href="#profile"
                      role="tab"
                      aria-controls="profile"
                      aria-selected={activeTab === "taxExpert"}
                      onClick={() => handleTabChange("taxExpert")}
                    >
                      Tax Experts Uploaded Documents
                    </a>
                  </li>
                </ul>
 
                <div className="tab-content" id="myTabContent">
                  {/* Client Uploaded Documents Tab */}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "client" ? "show active" : ""
                    }`}
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>S.No</th>
                            <th>Document Type</th>
                            <th>Uploaded On</th>
                            <th>Uploaded By</th>
                            <th>Comments</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records
                            .filter((document) => document.uploaded_client)
                            .map((document, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{document.type}</td>
                                <td>{document.uploaded_on}</td>
                                <td>{document.uploaded_client}</td>
                                <td>{document.comments}</td>
                                <td className="d-flex gap-2">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    title="Download PDF"
                                    onClick={() => {
                                      
                                      handleDownloaddoc(
                                        document.filePath.trim()
                                      );
                                    }}
                                  >
                                    Download
                                  </button>
                                  <button className="btn btn-sm btn-danger" onClick={() => {handleDelete(document.id)}}>Delete</button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
 
                  {/* Tax Expert Uploaded Documents Tab */}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "taxExpert" ? "show active" : ""
                    }`}
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>S.No</th>
                            <th>Document Type</th>
                            <th>Uploaded On</th>
                            <th>Uploaded By</th>
                            <th>Comments</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records
                            .filter((document) => document.uploaded_employee || document.uploaded_admin)
                            .map((document, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{document.type}</td>
                                <td>{document.uploaded_on}</td>
                                <td>{document.uploaded_employee || document.uploaded_admin}</td>
                                <td>{document.comments}</td>
                                <td className="d-flex gap-2">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    title="Download PDF"
                                    onClick={() => {
                                      
                                      handleDownloaddoc(
                                        document.filePath.trim()
                                      );
                                    }}
                                  >
                                    Download
                                  </button>
                                  <button className="btn btn-sm btn-danger" onClick={() => {handleDelete(document.id)}}>Delete</button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
 
                {/* Pagination */}
                <nav className="mt-2">
                  <ul className="pagination">
                    <li className="page-item">
                      <a href="#" className="page-link" onClick={prePage}>
                        Prev
                      </a>
                    </li>
                    {numbers.map((n, i) => (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={i}
                      >
                        <a
                          href="#"
                          className="page-link"
                          onClick={() => changeCpage(n)}
                        >
                          {n}
                        </a>
                      </li>
                    ))}
                    <li className="page-item">
                      <a href="#" className="page-link" onClick={nextPage}>
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
 
export default Clientviewdocs;
